(() => {
  const selectedMonth = '.drop-down-month-js'
  const init = () => {
    $('body').on('change', selectedMonth, onChange);
  }
  const onChange = e => {
    e.target.form.submit();
  }
  $(init);
})();

